import { BasicProps, Opt } from 'app/tools/general.types';
import React, { useEffect, useRef, useState } from 'react';
import AnimateHeight, {
  AnimateHeightProps,
} from 'react-animate-height';

type Props = {
  updateOn?: unknown;
} & BasicProps &
  Pick<AnimateHeightProps, 'onAnimationEnd'>;

export default function AutoHeightAnimation({
  children,
  className,
  updateOn,
  onAnimationEnd,
}: Props): JSX.Element {
  const boxRef = useRef<HTMLDivElement>(null);
  const [height, setHeight] = useState<Opt<string | number>>('auto');
  const setFixedHeight = () =>
    setHeight(boxRef.current?.clientHeight);

  const updateIfChanged =
    updateOn === undefined ? children : updateOn;
  useEffect(() => {
    setHeight('auto');
  }, [updateIfChanged]);

  useEffect(setFixedHeight, []);

  return (
    <AnimateHeight
      height={height}
      onAnimationEnd={data => {
        setFixedHeight();
        onAnimationEnd?.(data);
      }}
      {...{ className }}
    >
      <div ref={boxRef}>{children}</div>
    </AnimateHeight>
  );
}
